import api from '../api';

export const getConsentsByProject = projectId =>
  api.get(`/projects/${projectId}/consents`).then(res => res.data);

export const createConsent = (projectId, data) =>
  api.post(`/projects/${projectId}/consents`, data);

export const updateConsent = (projectId, id, data) =>
  api.put(`projects/${projectId}/consents/${id}`, data);

export const deleteConsent = (projectId, id)=>
  api.delete(`projects/${projectId}/consents/${id}`);

export const setActiveConsent = (projectId, consentId) =>
  api.post(`/projects/${projectId}/consents/${consentId}/activate`);
